var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionFailedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.033,
    height: 19.055,
    viewBox: "0 0 19.033 19.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "emergency_home_FILL1_wght700_GRAD0_opsz48",
    d: "M13.477,20.936a1.87,1.87,0,0,1-.664.465,2.072,2.072,0,0,1-.8.155,2.1,2.1,0,0,1-.786-.155,1.847,1.847,0,0,1-.675-.465L3.1,13.477a1.735,1.735,0,0,1-.454-.675,2.3,2.3,0,0,1-.144-.808,2.152,2.152,0,0,1,.144-.775,1.752,1.752,0,0,1,.454-.664L10.556,3.1a1.735,1.735,0,0,1,.675-.454,2.3,2.3,0,0,1,.808-.144,2.152,2.152,0,0,1,.775.144,1.752,1.752,0,0,1,.664.454l7.458,7.458a1.752,1.752,0,0,1,.454.664,2.212,2.212,0,0,1,.144.8,2.241,2.241,0,0,1-.144.786,1.735,1.735,0,0,1-.454.675Zm-1.461-7.9a.857.857,0,0,0,.642-.277.911.911,0,0,0,.266-.653V8.63a.907.907,0,1,0-1.815,0v3.475a.911.911,0,0,0,.266.653.857.857,0,0,0,.642.277Zm0,2.921a.907.907,0,0,0,.907-.907.886.886,0,0,0-.266-.631.883.883,0,0,0-1.284,0,.886.886,0,0,0-.266.631.907.907,0,0,0,.907.907Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#d52d34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionFailedIcon);
export default __webpack_public_path__ + "static/media/ActionFailedIcon.b054edc99421014c1c505b2fc7697373.svg";
export { ForwardRef as ReactComponent };